import { IProductDTO } from 'legacy/shared-types';
import { Card, Tooltip } from 'antd';
import { useIntl } from 'react-intl';
import { formatCurrency } from 'pages/BtlApplicationFormPage/CaseSummary/caseSummaryFormatters';
import { TypedFormatMessageFn } from 'types/intl';

interface OoProductItemProps extends React.HTMLAttributes<HTMLDivElement> {
  product: IProductDTO;
  isSelected?: boolean;
  onProductSelected?: (product: IProductDTO) => void;
  isSelectable: boolean;
  invalidated?: boolean;
}

export function OoProductItem({
  product,
  isSelected,
  onProductSelected,
  isSelectable,
  invalidated,
  ...props
}: OoProductItemProps) {
  const { formatMessage }: { formatMessage: TypedFormatMessageFn } = useIntl();

  const selectedCardClassName = invalidated
    ? 'border-2 border-yellow-500 bg-yellow-50/50'
    : 'border-2 border-[#008236] bg-[#DCFCE7]';
  const defaultCardClassName = invalidated
    ? 'border border-yellow-500'
    : 'border border-gray-200 hover:border-[#008236] cursor-pointer';

  const card = (
    <Card
      {...props}
      className={`h-[168px] w-[200px] transition ${isSelected ? selectedCardClassName : defaultCardClassName}
${!isSelectable && 'pointer-events-none'}
${props.className || ''}`}
      styles={{ body: { height: '100%', display: 'flex', flexDirection: 'column', gap: 8, padding: 12 } }}
      onClick={() => isSelectable && onProductSelected?.(product)}
    >
      <div className={'line-clamp-3 flex-1 font-bold leading-snug'}>{product.description}</div>
      <div className={'flex shrink-0 flex-col gap-2'}>
        <div className={'flex items-end gap-2'}>
          <div>{formatMessage({ id: 'ooApplicationForm.PRODUCT.rate.label' })}</div>
          <div className={'grow text-end text-lg font-bold'}>{(product.initialBaseRate * 100).toFixed(2)}%</div>
        </div>
        <div className={'flex items-end gap-2'}>
          <div>{formatMessage({ id: 'ooApplicationForm.PRODUCT.productFee.label' })}</div>
          <span className={'grow text-end text-lg font-bold'}>{formatCurrency(product.productFees)}</span>
        </div>
      </div>
    </Card>
  );

  return invalidated ? (
    <Tooltip
      defaultOpen
      style={{ visibility: invalidated ? 'visible' : 'hidden' }}
      title={formatMessage({ id: 'ooApplicationForm.PRODUCT.invalidated.label' })}
      placement={'bottom'}
    >
      {card}
    </Tooltip>
  ) : (
    card
  );
}
